export default {"src":"/_next/static/media/gpay-logo.9d739bdd.svg","height":400,"width":752,"blurWidth":0,"blurHeight":0};